/**
 * Archivo de constantes de textos
 */
export const lang = {
  //ROUTES
  ROUTE_URL_MY_ACCOUNT: "/su-cuenta",

  //COMMONS
  LABEL_MAXIPLUS: "MAXIplus",
  LABEL_ERROR: "Error",
  LABEL_ERROR_SERVICE_CONN:
    "No se ha podido establecer la conexión con el servidor.",
  LABEL_CLOSE: "Cerrar",
  LABEL_MIN: "MIN",

  TEXT_BTN_EXIST_RECURRENT_YES: "SI, QUIERO REEMPLAZAR MI COMBO RECURRENTE ACTUAL",
  TEXT_BTN_EXIST_RECURRENT_NO: "NO, QUIERO COMPRAR SOLO POR UNA VEZ",

  ONLY_ACTIVATE: "only-activate",



  LABEL_NO_DATA_FOUND: "No hay datos para mostrar",
  LABEL_APPLE_STORE: "APPLE STORE",
  LABEL_PLAY_STORE: "PLAY STORE",
  LABEL_GO_OUT: "Salir",
  LABEL_MODAL_SUCESS: "EL proceso terminó correctamente.",

  LABEL_CURRENT_RECURRENT: 'ACTUAL:',
  LABEL_NEW_RECURRENT: 'NUEVO:',


  LABEL_EXIST_RECURRENT:
    "Solo Puedes mantener un Combo Recurrente activo",
  LABEL_EXIST_RECURRENT_H: "¿DESEA REEMPLAZAR SU COMBO ACTUAL?",

  LABEL_INFORM_REPLACE_RECURRENT:
    "Su nuevo combo se activará cuando finalice",

  LABEL_INFORM_REPLACE_RECURRENT_TWO:
    "la vigencia del combo actual.",

  LABEL_TITLE_CONFIRM_REPLACE_RECURRENT: "SE HA REEMPLAZADO CORRECTAMENTE",
  LABEL_TITLE_CONFIRM_REPLACE_RECURRENT_TWO: "SU COMBO RECURRENTE ACTUAL",


  EMPTY_VALID_ONLY_RECURRENT: "",
  VALID_ONLY_RECURRENT: "only",


  //MENU
  MENU_LABEL_YOUR_ACCOUNT: "Su Cuenta",
  MENU_LABEL_PORTABILITY: "Cambiese a MAXIplus",
  MENU_LABEL_ACTIVATE: "Activese con RUC o Pasaporte",
  MENU_LABEL_RECHARGE: "Recarga",
  MENU_LABEL_COMBOS_BONUSES: "Compra de Combos",
  MENU_LABEL_SERVICES: "Servicios",
  MENU_LABEL_CONSULT: "Consulta",
  MENU_LABEL_PROMOS: "Promociones",
  MENU_LABEL_OTHER_SERVICES: "Otros servicios",


  //COBERTURA
  COVERAGE_MODAL_CONTENT_VALIDATION: "Lo sentimos las coordenadas no estan dentro del rango de cobertura.",

  //MAPS
  BTN_CONSULTAR_FILTER_FOUR: "Consultar",
  BTN_CONSULTAR_PARISHES_FILTER_ONE: "Consultar Parroquias",
  // URL_PATH_KML: "https://www.maxiplus.ec/UtilsMaxiplus/kmls/",
  URL_PATH_KML: "https://www.movistar.com.ec/cobertura-tecnologia-ec-portlet/html/coberturatecnologia/kml/2020_01_16/",


  //PORTABILITY
  PORTABILITY_MODAL_TITLE_INFO: "Información",
  PORTABILITY_MODAL_TITLE_SEND_REQUEST: "¡Su solicitud de portabilidad fue procesada correctamente!",
  PORTABILITY_MODAL_TITLE_SEND_REQUEST_CONTENT: "¡Puede seguir utilizando su celular! Recibirá una notificación para que realice el cambio de chip en su celular. Si tiene alguna duda por favor comuníquese al *103",
  PORTABILITY_MODAL_CONTENT_SEND_CODE: "Se ha enviado un mensaje de texto a su número móvil ",
  PORTABILITY_MODAL_TITLE_VALIDATION: "Validación",
  PORTABILITY_MODAL_CONTENT_VALIDATION: "Debe llenar todos los campos del formulario.",
  PORTABILITY_MODAL_CONTENT_AUT_TERMS: "Debe aceptar la autorización de cambiar de número y aceptar los términos y condiciones",
  PORTABILITY_MODAL_CONTENT_FINISH_REQUEST: "Se ha enviado la solicitud de portabilidad, recibirá una notificación por correo electrónico",
  PORTABILITY_LABEL_DOCUMENT_ID: "Ingrese su número de cédula",
  PORTABILITY_LABEL_NUMERIC_FIELD: "El campo debe ser numérico",
  PORTABILITY_LABEL_CURRENT_OPERATOR: "Seleccione la operadora",
  PORTABILITY_LABEL_CURRENT_CURRENT_PLAN: "Selecciona tu plan actual",
  PORTABILITY_LABEL_MY_LINE: "Mi línea es:",
  PORTABILITY_LABEL_PREPAID: "Prepago",
  PORTABILITY_LABEL_POSTPAID: "Postpago",
  PORTABILITY_LABEL_MY_NUMBER: "Ingrese su número de celular",
  PORTABILITY_LABEL_VALIDATE: "Si no ha recibido el NIP",
  PORTABILITY_LABEL_VALIDATE_LINK: "solicítelo nuevamente",
  PORTABILITY_LABEL_MSG_WRITE_CODE: "Ingrese el NIP de 4 dígitos enviado a su celular",
  PORTABILITY_LABEL_MSG_INFO_SMS_CODE: "Si no ha recibido el SMS, revise que el teléfono es correcto, pulse de nuevo el botón validar.",
  PORTABILITY_LABEL_CONTINUE: "Continuar",
  PORTABILITY_LABEL_BACK: "Volver",
  PORTABILITY_LABEL_PERSONAL_INFO: "Datos Personales",
  PORTABILITY_LABEL_ADDRESS: "Dirección",
  PORTABILITY_LABEL_NAMES: "Nombres",
  PORTABILITY_LABEL_ALPHANUMERIC_FIELD: "El campo debe ser alfanumérico",
  PORTABILITY_LABEL_CITY: "Ciudad",
  PORTABILITY_LABEL_LASTNAMES: "Apellidos",
  PORTABILITY_LABEL_FULL_ADDRESS: "Dirección exacta",
  PORTABILITY_LABEL_BORN_DATE: "Fecha de nacimiento",
  PORTABILITY_LABEL_DATE_FIELD: "Formato de fecha no válido",
  PORTABILITY_LABEL_ADDITIONAL_NUMBER: "Número para notificaciones",
  PORTABILITY_LABEL_EMAIL: "Dirección de correo electrónico",
  PORTABILITY_LABEL_EMAIL_FIELD: "Formato de email no válido",
  PORTABILITY_LABEL_ICC: "Ingrese el número de ICC de su Chip MAXIplus",
  PORTABILITY_LABEL_DOWNLOAD_FORM: "Solicitud de Portabilidad",
  PORTABILITY_LABEL_DOWNLOAD_BTN: "Descargar",
  PORTABILITY_LABEL_UPLOAD_FORM: "Solicitud de Portabilidad",
  PORTABILITY_LABEL_UPLOAD_BTN: "Cargar",
  PORTABILITY_LABEL_UPLOAD_DOCUMENT_COPY: "1 archivo",
  PORTABILITY_LABEL_UPLOAD_DOCUMENT_COPY_SUB: "(Dos lados de la CI)",
  PORTABILITY_LABEL_UPLOAD_DOCUMENT_COPY_FRONT: "Frente",
  PORTABILITY_LABEL_UPLOAD_DOCUMENT_COPY_REVERSE: "Reverso",
  PORTABILITY_LABEL_SEND: "Finalizar",
  PORTABILITY_LABEL_HEADER_TITLE: "Puede cambiarse a MAXIplus con:",
  PORTABILITY_LABEL_HEADER_YOUR_NUMBER: "Su número",
  PORTABILITY_LABEL_HEADER_NEW_NUMBER: "Nuevo número",
  PORTABILITY_LABEL_TAB_STEP_1: "Adquiera su chip MAXIplus",
  PORTABILITY_LABEL_TAB_STEP_2: "Complete sus datos",
  PORTABILITY_LABEL_TAB_STEP_3: "Firme y suba su solicitud",
  PORTABILITY_LABEL_CONTENT_TITLE_1_STEP_1: "Adquiera su chip MAXIplus y tenga a la mano su celular con la línea que quiera conservar para poder continuar con este proceso",
  PORTABILITY_LABEL_CONTENT_CHIP_STORE_DESC: "Encuentre su chip MAXIplus en cualquiera de nuestros Super Mercados MAXIplus del País",
  PORTABILITY_LABEL_CONTENT_TITLE_1_STEP_2: "Complete toda la información de su línea y equipo actual",
  PORTABILITY_LABEL_IMEI: "Ingrese el IMEI de su equipo celular",
  PORTABILITY_LABEL_CONTENT_TITLE_2_STEP_2:
    "Verifique y complete sus datos personales",
  PORTABILITY_LABEL_CONTENT_TITLE_1_STEP_3: "Descargue su Solicitud",
  PORTABILITY_LABEL_CONTENT_TITLE_2_STEP_3:
    "Suba su solicitud completa y firmada",
  //PORTABILITY_LABEL_CONTENT_TITLE_3_STEP_3:"Puede ser escaneada o una foto de la solicitud. (.PDF, .JPEG, .DOC)"
  PORTABILITY_LABEL_CONTENT_TITLE_3_STEP_3:
    "Puede ser escaneada o una foto de la solicitud. (.PDF, .JPEG)",
  PORTABILITY_LABEL_CONTENT_TITLE_4_STEP_3:
    "Suba una copia de su cédula de Identidad",
  //PORTABILITY_LABEL_CONTENT_TITLE_5_STEP_3:"Puede subir 1 archivo con los 2 lados de su cédula o subir 1 archivo por cada lado de su cédula. (.PDF, .JPEG, .DOC)",
  PORTABILITY_LABEL_CONTENT_TITLE_5_STEP_3:"Puede subir 1 archivo con los 2 lados de su cédula o subir 1 archivo por cada lado de su cédula. (.PDF, .JPEG)",
  PORTABILITY_LABEL_MODAL_VALIDATION_ICC_ERROR:
    "El ICC ingresado no es válido, por favor verifique e intente nuevamente.",
  PORTABILITY_LABEL_MODAL_VALIDATION_USER_INFO_ERROR:
    "No se pudo obtener información sobre la cédula, por favor verifique o intente mas tarde.",
  PORTABILITY_LABEL_MODAL_ERORO_SEND_SMS:
    "No se ha podido enviar el PIN. por favor verifique e intente nuevamente",
  PORTABILITY_MODAL_CONTENT_INVALID_PHONE_VALIDATION:
    "El número ingresado no es válido",
  PORTABILITY_TOOLTIP_ICC: "El ICC es un número de 19 dígitos que se encuentra en la parte inferior izquierda de su Chip MAXIplus",
  PORTABILITY_TOOLTIP_IMEI: "El IMEI es un número de 15 dígitos que se encuentra en <b>Configuración General > Información </b> o marcando desde su celular *#06#",
  PORTABILITY_TOOLTIP_ADDNUM: "Número telefónico opcional al cual se enviarán notificaciones por mensaje de texto",
  PORTABILITY_LABEL_UPLOAD_FRONT_AND_REVERSE: "Suba el frente y reverso de su cédula por separado",
  PORTABILITY_LABEL_UPLOAD: "Seleccionar archivo",
  PORTABILITY_LABEL_MODAL_ERROR_SENDING_REQUEST: "Ha ocurrido un error enviando la petición de portabilidad. intente más tarde.",
  PORTABILITY_LABEL_MODAL_ERROR_IMEI: "El IMEI ingresado no es válido.",
  PORTABILITY_LABEL_SUPPORT: `<strong>Si requiere asistencia en su proceso de portabilidad, 
  favor comunicarse al 0958700020 o enviar correo a <u>servicio@maxiplus.ec</u><strong>`,

  //PRIVACIDAD
  PRIVACY_LABEL_TITLE_INFO: "Privacidad",

  //SERVICE MENU
  SERVICE_MENU_LABEL_TITLE: "¿Qué desea hacer?",
  SERVICE_MENU_LABEL_ITEM_1: "Cambio de número",
  SERVICE_MENU_LABEL_ITEM_2: "Reposición de Chip",
  SERVICE_MENU_LABEL_ITEM_3: "Liberación / Suspensión",
  SERVICE_MENU_LABEL_ITEM_4: "Detalles de llamadas",
  SERVICE_MENU_LABEL_ITEM_5: "Otros Servicios",
  SERVICE_MENU_LABEL_ITEM_DESC_1:
    "Para su mayor comodidad aquí puede solicitar cambio de su número telefónico.",
  SERVICE_MENU_LABEL_ITEM_DESC_2:
    "En esta opción puede realizar el cambio de su CHIP por pérdida, daño o robo.",
  SERVICE_MENU_LABEL_ITEM_DESC_3:
    "En esta opción puede suspender o reactivar su línea en caso de recuperar su CHIP anterior",
  SERVICE_MENU_LABEL_ITEM_DESC_4:
    "Quiere saber el detalle de sus movimientos, llamadas entrantes y salientes. Solicitalo aquí.",
  SERVICE_MENU_LABEL_ITEM_DESC_5:
    "Puede escribirnos sus requerimientos o sugerencias, con gusto las atenderemos.",

  //TERMS AND CONDITIONS
  TERMS_CONDITIONS_LABEL_TITLE_INFO: "Términos y Condiciones",

  //FREQUENT QUESTIONS
  FREQUENT_QUESTIONS_LABEL_TITLE_INFO: "Preguntas frecuentes",

  //REGISTRATION_GUIDE
  REGISTRATION_GUIDE_LABEL_TITLE: "¡ACTÍVELO INMEDIATAMENTE!",
  REGISTRATION_GUIDE_LABEL_SUB_TITLE: "En 3 sencillos pasos:",
  REGISTRATION_GUIDE_LABEL_STEP_ICON_1: "1",
  REGISTRATION_GUIDE_LABEL_STEP_ICON_2: "2",
  REGISTRATION_GUIDE_LABEL_STEP_ICON_3: "3",
  REGISTRATION_GUIDE_LABEL_STEP_DESC_1: "Adquiera<br> su chip MAXIplus<br> en Supermaxi y Megamaxi.",
  REGISTRATION_GUIDE_LABEL_STEP_DESC_2: `Inserte su nuevo<br> Chip MAXIplus<br> en su celular y haga<br>
   una llamada a cualquier<br> número celular<br> o convencional.`,
  REGISTRATION_GUIDE_LABEL_STEP_DESC_3: `Antes de finalizar<br> la llamada,<br> el 
  sistema le solicitará<br> ingresar su nombre<br> y número de cédula.`,
  REGISTRATION_GUIDE_LABEL_LINK_PORTABILITY:
    "*Active su línea con su pasaporte",

  //BENEFITS
  BENEFITS_LABEL_IFO_TITLE: "¿POR QUÉ CAMBIARSE A <span class='f-karla-bold'>MAXIplus<b>?",
  BENEFITS_LABEL_IFO_DESC: `Ahora sus compras suman beneficios. Compre productos marca Supermaxi<br>
   y acumule el 10% en MAXIRecargas. Si es cliente con pago recurrente reciba el 15%`,
  BENEFIT_LABEL_CIRCLE_TITLE_1: "Atención 24 horas",
  BENEFIT_LABEL_CIRCLE_1: "Todos sus requerimientos y necesidades lo soluciona con un clic.",
  BENEFIT_LABEL_CIRCLE_TITLE_2: "Maxicombos",
  BENEFIT_LABEL_CIRCLE_2: "En combos, bonos y recargas, le damos siempre lo mejor.",
  BENEFIT_LABEL_CIRCLE_TITLE_3: "Cobertura nacional",
  BENEFIT_LABEL_CIRCLE_3: "Nuestra señal cubre todo el territorio nacional.",
  BENEFIT_LABEL_CIRCLE_TITLE_4: "Mantenga su número",
  BENEFIT_LABEL_CIRCLE_4: "Cámbiese sin contrato y con su mismo número. No pierda tiempo.",

  //COMBOS-HOME
  COMBOS_HOME_LABEL_TITLE: `HABLE Y NAVEGUE <br> <span class="f-karla-bold">Con su COMBO preferido</span>`,
  COMBOS_HOME_LABEL_SUB_TITLE: `Active su combo incluso con sus MaxiRecargas y compleméntelo con 
  cualquiera de nuestros bonos. `,
  COMBOS_HOME_LABEL_P:
    "Si no tiene saldo en su cuenta no se preocupe, también puede comprarlos y en la misma pantalla.",
  COMBOS_HOME_LABEL_COMBOS: "VER COMBOS",
  COMBOS_HOME_LABEL_BONUSES: "VER BONOS",
  COMBOS_HOME_LABEL_BTN_BUY: "Comprar",
  COMBOS_HOME_LABEL_LINK_COMBOS: "Ver todos los Combos",
  COMBOS_HOME_LABEL_LINK_BONUSES: "Ver todos los Bonos",
  COMBOS_HOME_BUTTON_BUY: "COMPRAR",
  COMBOS_HOME_WITHOUT_BONUS: "No hay bonus para mostrar",
  COMBOS_HOME_WITHOUT_COMBOS: "no hay combos para mostrar",
  COMBOS_HOME_VALIDITY: "Vigencia",
  COMBOS_HOME_VALIDITY_DAYS: "días",
  COMBOS_HOME_VALIDITY_DAY: "día",
  COMBOS_HOME_TITLE_RIGHT_SUB_1: "Combos para ",
  COMBOS_HOME_TITLE_RIGHT_SUB_2: "TODO EL MES",
  COMBOS_HOME_TITLE_RIGHT_SUB_3: "Bonos ",
  COMBOS_HOME_TITLE_RIGHT_SUB_4: "MAXIplus",
  COMBOS_HOME_UNLIMITED: "Ilimitado",

  //MOVISTAR-PLAY
  MOVISTAR_PLAY_TITLE: "MOVISTAR PLAY GRATIS",
  MOVISTAR_PLAY_TITLE_2: "DEPORTES, ENTRETENIMIENTO Y MAS",
  MOVISTAR_PLAY_DESC: "Movistar Play el complemento perfecto en su línea Maxiplus con navegación incluida.",
  MOVISTAR_PLAY_DESC_2:
    "entretenimiento, contenido exclusivo Movistar y canales en vivo.",
  MOVISTAR_PLAY_MORE: "Conoce más",

  //SERVICE MENU HOME
  SERVICE_MENU_HOME_LABEL_TITLE: `Servicios <span class='f-karla-bold'>MAXIplus</span> en línea`,
  SERVICE_MENU_HOME_LABEL_LINK_MORE: "Ver todos los servicios",
  SERVICE_MENU_HOME_LABEL_RECHAGE: "RECARGAR",
  SERVICE_MENU_HOME_LABEL_TITLE_RECHAGE: "Hacer<br> una Recarga",
  SERVICE_MENU_HOME_LABEL_DESC_RECHAGE: `Compre una recarga<br>
 de $2 a $30 <br>
 para cualquier <br>
 número MAXIplus <br>
 con tarjeta <br>
 de crédito o débito`,
  SERVICE_MENU_HOME_LABEL_PORTABILITY: "QUIERO SER MAXIplus",
  SERVICE_MENU_HOME_SLIDER_PORTABILITY: "SER MAXIplus",
  SERVICE_MENU_HOME_LABEL_TITLE_PORTABILITY: "CAMBIARSE<br> A MAXIplus",
  SERVICE_MENU_HOME_LABEL_DESC_PORTABILITY: `Cámbiese con<br>
  su número actual<br>
  o adquiera uno nuevo<br>
  y obtenga todos<br>
  los beneficios MAXIplus<br>`,
  SERVICE_MENU_HOME_LABEL_SUSPEND: "SUSPENDER",
  SERVICE_MENU_HOME_LABEL_TITLE_SUSPEND: "¿PERDIÓ<br> SU CELULAR?",
  SERVICE_MENU_HOME_LABEL_DESC_SUSPEND: `Suspenda su línea<br>
  de manera temporal<br>
  o definitiva llenando<br>
  el siguiente formulario<br><br>`,
  SERVICE_MENU_HOME_LABEL_REPO_CHIP: "CONOCE MÁS",
  SERVICE_MENU_HOME_LABEL_TITLE_REPO_CHIP: "FALLAS <br> EN EL CHIP",
  SERVICE_MENU_HOME_LABEL_DESC_REPO_CHIP: `Solicite<br>
  una reposición de chip<br>
  con el mismo número<br>
  o uno nuevo llenando<br>
  el siguiente formulario<br>`,
  //CARE-CHANNELS
  CARE_CHANNELS_TITTLE: `Todos los servicios de <span class="f-karla-bold font-w-900">MAXIplus</span><br> disponibles en su canal favorito`,
  CARE_CHANNELS_DESC: "Recargas, detalles de consumo, estados de su línea y más",
  CARE_CHANNELS_SERVICE_1: `Su app <br><span class="f-karla-bold">MAXIplus</span>`,
  CARE_CHANNELS_TITLE_FOOTER: `Otras formas de activar su combo`,
  CARE_CHANNELS_SERVICE_MAXIPLUS: "MAXIplus",
  CARE_CHANNELS_SERVICE_2: `Su web <br><span class="f-karla-bold">MAXIplus</span>`,
  CARE_CHANNELS_SERVICE_3: `Desde su <br><span class="f-karla-bold">CELULAR</span>`,
  CARE_CHANNELS_SERVICE_2_DES: "www.maxiplus.ec",
  CARE_CHANNELS_SERVICE_3_DES: "*103",
  CARE_CHANNELS_SERVICE_3_1DES: "desde su celular",

  //FOOTER
  FOOTER_TITLE: "MAXIplus",
  FOOTER_SUBTITLE: "Una marca de Corporación Favorita ©2019",
  FOOTER_OP_HELP: "Ayuda",
  FOOTER_OP_ARCOTEL: "Arcotel",
  FOOTER_OP_COVERAGE: "Cobertura",
  FOOTER_OP_LEGAL_NOTICES: "Avisos Legales",
  FOOTER_PRIVACY: "Privacidad",
  FOOTER_OP_NORMATIVES: "Normativas",
  FOOTER_OP_QUALITY_INDICES: "Índices de calidad",
  FOOTER_OP_SUBSCRIBER_REGULATION: "Reglamento de Abonados",
  FOOTER_OP_EQUIPMENT_HOMOLOGATION: "Homologación de equipos",
  FOOTER_OP_FOLLOW_US: "Síguenos en:",
  FOOTER_SUB_FOOTER: "Servicio prestado por OTECEL S.A.",
   //GD-1335
   FOOTER_OP_USO_911: "911",


  //SUSPEND-LINE-EQUIP
  SUPEND_LINE_EQUIP_TITLE: "Suspensión de Línea o Equipo",
  SUPEND_LINE_EQUIP_DESC: `Al suspender su línea o equipo, estos <span class="f-karla-bold">no podrán ser utilizados</span>
 hasta que sean reactivados nuevamente desde <span class="f-karla-bold">su cuenta</span>.`,
  SUPEND_LINE_EQUIP_SUBTITLE: "Seleccione su línea y verifique su equipo asociado",
  SUPEND_LINE_EQUIP_SUSPEND_TITLE: "¿Qué desea suspender?",
  SUPEND_LINE_EQUIP_SUSPEND_LINE: "Línea",
  SUPEND_LINE_EQUIP_SUSPEND_EQUIP: "Equipo",
  SUPEND_LINE_EQUIP_SUSPEND_LINE_EQUIP: "Línea y Equipo",
  SUPEND_LINE_EQUIP_NOTIFICATION: "Datos de notificación",
  SUPEND_LINE_EQUIP_PHONENUMBER: "Número de teléfono alterno ",
  SUPEND_LINE_EQUIP_EMAIL: "Correo electrónico",
  SUPEND_LINE_EQUIP_KEY: "Registre una clave de seguridad para liberación",
  SUPEND_LINE_EQUIP_KEY_NUMBER: "4 dígitos",
  SUPEND_LINE_EQUIP_KEY_NUMBER_DESC: `Cuando quiera reactivar su línea y/o equipo, se solicitará esta clave`,
  SUPEND_LINE_EQUIP_SUSPEND: "Suspender",
  SUPEND_LINE_EQUIP_IMEI: "IMEI",
  SUPEND_LINE_EQUIP_SUSPEND_CONFIRMATION: "¿ESTÁ SEGURO QUE QUIERE SUSPENDER?",
  SUPEND_LINE_EQUIP_SUSPEND_CONFIRMATION_LINE: "LÍNEA MAXIplus",
  SUPEND_LINE_EQUIP_SUSPEND_CONFIRMATION_EQUIP: "SU EQUIPO",
  SUPEND_LINE_EQUIP_SUSPEND_CONFIRMATION_IMEI: "IMEI",
  SUPEND_LINE_EQUIP_SUSPEND_CONFIRMATION_OK: "Sí, suspender",
  SUPEND_LINE_EQUIP_SUSPEND_CONFIRMATION_BACK: "No, regresar",
  SUPEND_LINE_EQUIP_LINE_ALERT: "Debe seleccionar una línea",
  SUPEND_LINE_EQUIP_MODAL_CONFIRMATION_PART1: "La suspensión de la Línea, se ha registrado con éxito. Ticket: ",
  SUPEND_LINE_EQUIP_MODAL_CONFIRMATION_PART1B: "La suspensión del equipo, se ha registrado con éxito. Ticket:",
  SUPEND_LINE_EQUIP_MODAL_CONFIRMATION_PART2: " En un plazo máximo de 30 minutos estará suspendida",
  SUPEND_LINE_EQUIP_MODAL_CONFIRMATION_PART2B: " En un plazo máximo de 30 minutos estará suspendido",
  SUPEND_LINE_EQUIP_MODAL_CONFIRMATION: "Su Línea o Equipo fue reportada con éxito. Número de Ticket: ",
  SUPEND_LINE_EQUIP_MODAL_SUSPEND_ERROR: "No fue posible suspender la Línea o Equipo seleccionado, por favor intente más tarde.",
  SUPEND_LINE_EQUIP_DESC_FAIL_STEP: "Si tiene alguna duda, comuníquese al *103",
  //ACTIVATION RUC PASSPORT
  ACTIVATION_MODAL_TITLE_INFO: "Información",
  ACTIVATION_MODAL_TITLE_SEND_REQUEST: "¡Su solicitud de activacion por pasaporte fue procesada correctamente!",
  ACTIVATION_MODAL_CONTENT_VALIDATION: "Debe llenar todos los campos del formulario.",
  ACTIVATION_LABEL_NUMERIC_FIELD: "El campo debe ser numérico",
  ACTIVATION_LABEL_VALIDATE: "Si no ha recibido el PIN",
  ACTIVATION_LABEL_VALIDATE_LINK: "solicítelo nuevamente",
  ACTIVATION_LABEL_MSG_WRITE_CODE: "Ingrese el PIN de 4 dígitos enviado a su celular",
  ACTIVATION_LABEL_MSG_INFO_SMS_CODE: "Si no ha recibido el SMS, revise que el teléfono es correcto, pulse de nuevo el botón validar.",
  ACTIVATION_LABEL_CONTINUE: "Continuar",
  ACTIVATION_LABEL_BACK: "Volver",
  ACTIVATION_LABEL_PERSONAL_INFO: "Datos Personales",
  ACTIVATION_LABEL_ADDRESS: "Dirección",
  ACTIVATION_LABEL_NAMES: "Nombres",
  ACTIVATION_LABEL_ALPHANUMERIC_FIELD: "El campo debe ser alfanumérico",
  ACTIVATION_LABEL_CITY: "Ciudad",
  ACTIVATION_LABEL_LASTNAMES: "Apellidos",
  ACTIVATION_LABEL_FULL_ADDRESS: "Dirección exacta",
  ACTIVATION_LABEL_BORN_DATE: "Fecha de nacimiento",
  ACTIVATION_LABEL_DATE_FIELD: "Formato de fecha no válido",
  ACTIVATION_LABEL_ADDITIONAL_NUMBER: "Número para notificaciones",
  ACTIVATION_LABEL_EMAIL: "Ingrese su dirección de correo electrónico",
  ACTIVATION_LABEL_EMAIL_FIELD: "Formato de email no válido",
  ACTIVATION_LABEL_ICC: "Ingrese el número de ICC de su Chip MAXIplus",
  ACTIVATION_LABEL_DOWNLOAD_FORM: "Solicitud de activacion por pasaporte",
  ACTIVATION_LABEL_DOWNLOAD_BTN: "Descargar",
  ACTIVATION_LABEL_UPLOAD_FORM: "Seleccionar archivo",
  ACTIVATION_LABEL_UPLOAD_BTN: "Cargar",
  ACTIVATION_LABEL_SEND: "Finalizar",
  ACTIVATION_LABEL_PASSPORT: "Pasaporte",
  ACTIVATION_LABEL_HEADER_TITLE: "Complete los siguientes pasos para activar su nueva línea MAXIplus con su Pasaporte.",
  ACTIVATION_LABEL_HEADER_YOUR_NUMBER: "Su número",
  ACTIVATION_LABEL_HEADER_NEW_NUMBER: "Nuevo número",
  ACTIVATION_LABEL_TAB_STEP_1: "Adquiere su CHIP MAXIplus",
  ACTIVATION_LABEL_TAB_STEP_2: "Complete los siguientes datos",
  ACTIVATION_LABEL_TAB_STEP_3: "Suba una copia de su Pasaporte",
  ACTIVATION_LABEL_CONTENT_TITLE_1_STEP_1: "¿Ya cuenta con su Chip MAXIplus?",
  ACTIVATION_LABEL_CONTENT_TITLE_2_STEP_1: "Puede subir un archivo PDF, DOC o JPEG con la copia de su documento",
  ACTIVATION_LABEL_CONTENT_CHIP_STORE_DESC: "Encuentre su Chip MAXIplus en cualquiera de nuestros Super Mercados MAXIplus del País",
  ACTIVATION_LABEL_CONTENT_TITLE_1_STEP_2: "Seleccione el tipo de documento:",
  ACTIVATION_LABEL_IMEI: "Ingrese el IMEI de su equipo celular",
  ACTIVATION_LABEL_CONTENT_TITLE_2_STEP_3: "Sube una copia de su documento de Identidad",
  ACTIVATION_LABEL_CONTENT_TITLE_3_STEP_3: "Puede subir un archivo PDF, DOC o JPEG con la copia de su documento",
  ACTIVATION_LABEL_SELECT_DOC_TO_UPLOAD: "Seleccione el tipo de documento",
  //ACTIVACTION PASSPORT
  ACTIVACTION_PASSPORT_LABEL_FINISH_PROCESS_1: "¡Su solicitud fue procesada correctamente!",
  ACTIVACTION_PASSPORT_LABEL_FINISH_PROCESS_2: "En 2 horas podrá utilizar el servicio de línea celular",
  ACTIVACTION_PASSPORT_LABEL_FINISH_PROCESS_3: "*Si tiene alguna duda comuníquese al *103",
  //RELEASE-LINE-EQUIP
  RELEASE_LINE_EQUIP_TITLE: "Liberar Línea o Equipo",
  RELEASE_LINE_EQUIP_SUB_TITLE: `Para liberar su línea o equipo debe recordar
su clave de liberación que ingresó al suspenderlos.`,
  RELEASE_LINE_EQUIP_DESC: "Seleccione su línea y verifique su equipo asociado",
  RELEASE_LINE_EQUIP_QUESTION: "¿Qué desea liberar?",
  RELEASE_LINE_IMEI: "IMEI:",
  RELEASE_LINE_EQUIP_SUSPEND_LINE: "Línea",
  RELEASE_LINE_EQUIP_SUSPEND_EQUIP: "Equipo",
  RELEASE_LINE_EQUIP_SUSPEND_LINE_EQUIP: "Línea y Equipo",
  RELEASE_LINE_EQUIP_NOTIFICATION: "Datos de notificación",
  RELEASE_LINE_EQUIP_PHONENUMBER: "Número de teléfono alterno",
  RELEASE_LINE_EQUIP_EMAIL: "Correo electrónico",
  RELEASE_LINE_EQUIP_KEY: "Ingrese la clave de seguridad para liberación",
  RELEASE_LINE_EQUIP_KEY_DESC: "*Esta clave de seguridad fue creada al momento de suspender su línea y/o equipo.",
  RELEASE_LINE_EQUIP_BUTTON: "Liberar",
  //RELEASE Modal One
  RELEASE_LINE_EQUIP_INCORRECT_KEY_TITLE: "¡Lo sentimos!",
  RELEASE_LINE_EQUIP_INCORRECT_KEY_DESC: "La clave ingresada es incorrecta",
  RELEASE_LINE_EQUIP_OPT_AGAIN: "Intentar nuevamente",
  RELEASE_LINE_EQUIP_OPT_OTHER: "Probar de otra manera",
  RELEASE_LINE_EQUIP_DESC_FAIL_STEP: "Si tiene alguna duda, comuníquese al *103",

  RELEASE_LINE_EQUIP_SUSPEND_TITLE: "Suspendido",
  RELEASE_LINE_EQUIP_LABEL_MODAL_ERROR_NO_LINES: "No se encontraron líneas para el usuario",
  //RELEASE Questions
  RELEASE_LINE_EQUIP_SUB_TITLE_STEP2: `Para liberar su línea o equipo, 
responda correctamente las siguientes preguntas`,
  RELEASE_LINE_EQUIP_SUBTITLE_STEP2: "Para liberar su línea",
  //RELEASE   Modal two
  RELEASE_LINE_EQUIP_RELEASEOK_STEP2: "¡Su Línea fue Liberada!",
  RELEASE_LINE_EQUIP_YOURLINE_STEP2: "Su línea",
  RELEASE_LINE_EQUIP_FINISH_STEP2: "fue liberada exitosamente.",
  RELEASE_LINE_EQUIP_BUTTON_FINISH: "REPOSICIÓN DE CHIP",

  //RELEASE   Modal THREE
  RELEASE_LINE_EQUIP_SUBTITLEFAIL_STEP2: `No ha respondido correctamente las,
preguntas de validación`,
  RELEASE_LINE_EQUIP_EXIT: 'SALIR',
  RELEASE_LINE_EQUIP_ANSWER_UNSELECT: "Debe seleccionar una respuesta para cada pregunta.",

  RELEASE_LINE_EQUIP_ALERTCHIP_STEP2: "Si no cuenta con un Chip puede iniciar ",
  RELEASE_LINE_EQUIP_ALERTCHIP2_STEP2: " su proceso de reposición de Chip.",
  RELEASE_LINE_EQUIP_LABEL_MODAL_ERROR_NO_IMEI_SUSPENDED: "La línea seleccionada no tiene un IMEI registrado.",
  RELEASE_LINE_EQUIP_RELEASE_OK_REQUEST_FINAL: "Su Línea o Equipo fue liberado correctamente. Número de Ticket: ",
  RELEASE_LINE_EQUIP_RELEASE_ERROR_REQUEST_FINAL: "No se ha podido liberar su Línea o equipo. por favor intente más tarde.",
  RELEASE_LINE_EQUIP_LABEL_MODAL_ERROR_NO_VERIFICATION_QUESTIONS: "No hay preguntas de verificación de identidad disponibles",

  //ACTIVATION_MENU
  ACTIVATION_MENU_LABEL_HEADER_TITLE: "Cambiarse a ",
  ACTIVATION_MENU_LABEL_HEADER_SUBTITLE: "Encuentre su Chip MAXIplus en cualquiera de nuestros supermercados:",
  ACTIVATION_MENU_LABEL_HEADER_SUBTITLE_2: "Seleccione su forma de cambiarse a MAXIplus",
  ACTIVATION_MENU_LABEL_TAB_STEP_1: "Conservar mi número actual",
  ACTIVATION_MENU_LABEL_TAB_STEP_2: "Nuevo número con Cédula",
  ACTIVATION_MENU_LABEL_TAB_STEP_3: "Nuevo número con Pasaporte",

  //ACTIVATION_DOCUMENT
  ACTIVATION_DOCUMENT_LABEL_SUB_TITLE: "Complete los siguientes pasos para activar su nueva línea MAXIplus con su cédula",
  ACTIVATION_DOCUMENT_LABEL_STEP_DESC_1: "Consiga su Chip MAXIplus Supermaxi y Megamaxi.",
  ACTIVATION_DOCUMENT_LABEL_STEP_DESC_2: "Inserte su nuevo Chip MAXIplus en su celular y haga una llamada a cualquier número celular o convencional.",
  ACTIVATION_DOCUMENT_LABEL_STEP_DESC_3: "Antes de finalizar la llamada, el sistema le solicitará ingresar su nombre y número de cédula.",

  //CALL_LOG_DETAL
  CALL_LOG_DETAIL_TITLE: "Detalle de Llamadas",
  CALL_LOG_DETAIL_SUB_TITLE: "Con esta solicitud le enviaremos una lista con los números a los que ha llamado o le han llamado.",
  CALL_LOG_DETAIL_DESC: "Seleccione la línea de la que desea el detalle de llamadas",
  CALL_LOG_DETAIL_QUESTION: "Seleccione el tipo de llamadas del que desea el detalle",
  CALL_LOG_DETAIL_INCOMING: "Entrantes",
  CALL_LOG_DETAIL_OUTCOMING: "Salientes",
  CALL_LOG_DETAIL_BUTTON: "Solicitar detalle de Llamadas",
  CALL_LOG_DETAIL_BRAND_AUTHORIZATION: "Autorizo a MAXIplus a emitir el detalle de Llamadas de la línea",
  CALL_LOG_DETAIL_BRAND_DEBIT_AUTHORIZATION_1: "Autorizo a MAXIplus a debitar ",
  CALL_LOG_DETAIL_BRAND_DEBIT_AUTHORIZATION_2: " de mi saldo de Recargas de la línea",
  CALL_LOG_DETAIL_BRAND_TERMS_CONDITIONS: "Acepto ",
  CALL_LOG_DETAIL_BRAND_TERMS_CONDITIONS_LINK: "Términos y Condiciones",
  CALL_LOG_DETAIL_DATE_RANGE: "Seleccione el período del que desea el detalle",
  CALL_LOG_DETAIL_MODAL_TITLE: "Validación",
  CALL_LOG_DETAIL_MODAL_CONTENT: "Debe llenar todos los campos del formulario.",
  CALL_LOG_DETAIL_MODAL_TITLE_REQUEST_SENT: "¡Su Solicitud de Detalle de llamadas se procesó correctamente!",
  CALL_LOG_DETAIL_MODAL_CONTENT_1_REQUEST_SENT: "Se enviará el detalle de llamadas del período:",
  CALL_LOG_DETAIL_MODAL_CONTENT_2_REQUEST_SENT: "a",
  CALL_LOG_DETAIL_MODAL_CONTENT_3_REQUEST_SENT: "a su correo",
  CALL_LOG_DETAIL_MODAL_CONTENT_4_REQUEST_SENT: "en 48 horas",
  CALL_LOG_DETAIL_MODAL_CONTENT_FOOTER_REQUEST_SENT: "Si tiene alguna duda comuníquese al *103",
  CALL_LOG_DETAIL_MODAL_TITLE_TERMS: "Términos y condiciones",
  CALL_LOG_DETAIL_MODAL_AUTH_TITLE: "Validación",
  CALL_LOG_DETAIL_MODAL_AUTH_CONTENT: "Debe aceptar la autorización de emitir el detalle de llamadas y aceptar los términos y condiciones",
  CALL_LOG_DETAIL_MODAL_DATE_ERROR_TITLE: "Validación",
  CALL_LOG_DETAIL_MODAL_DATE_ERROR_CONTENT: "Debe seleccionar una fecha inicial menor a la fecha final y menor al día actual",
  CALL_LOG_DETAIL_DAYS_TO_CONTEMPLATE: "Días a contemplar",
  CALL_LOG_DETAIL_COST: "Costo Total a pagar para solicitar el servicio",
  CALL_LOG_DETAIL_BALANCE: "Saldo en recargas del",
  CALL_LOG_DETAIL_INSUFFICIENT_BALANCE: "No cuenta con saldo suficiente",
  CALL_LOG_DETAIL_COST_VALUE: "380",
  CALL_LOG_DETAIL_LABEL_ERROR_NO_MONEY: "Ha ocurrido un error al obtener el saldo de la línea seleccionada",
  CALL_LOG_DETAIL_LABEL_END_DATE_WRONG: "La fecha final no puede superar el día de hoy",
  CALL_LOG_DETAIL_LABEL_INIT_DATE_WRONG: "La fecha inicial no puede ser mayor a la fecha final",
  CALL_LOG_DETAIL_MAX_DAYS_ALLOWED: "El número máximo de días permitidos es de 360",
  CALL_LOG_DETAIL_DATE_FORM: "Fecha desde",
  CALL_LOG_DETAIL_DATE_TO: "Fecha hasta",
  CALL_LOG_DETAIL_SELECT_LINE: "Seleccione una línea...",
  CALL_LOG_TOOLTIP_RANGE: "Rango de fechas entre las cuales desea tener el registro de llamadas",
  CALL_LOG_TOOLTIP_COST: "Costo de la transacción que será descontado de su saldo",
  CALL_LOG_DETAIL_LABEL_ERROR_REQUEST: "No se ha podido completar la solicitud. por favor intente más tarde.",

  //CHANGE-NUMBER
  CHANGE_NUMBER_TITLE: "Cambiar mi Número",
  CHANGE_NUMBER_SUB_TITLE: "Con esta solicitud su número actual será dado de baja, es decir no le ",
  CHANGE_NUMBER_SUB_TITLE2: "pertenece más, MAXIplus le otorgará un número nuevo.",
  CHANGE_NUMBER_DESC: "Seleccione su línea y verifique que sea el número que desea cambiar",
  CHANGE_NUMBER_DESC_AUTHORIZATION: "Autorizo a MAXIplus a cambiar mi número actual",
  CHANGE_NUMBER_TERMS: "Acepto Términos y Condiciones",
  CHANGE_NUMBER_BUTTON: "Cambiar número",
  CHANGE_NUMBER_BUTTON_MODAL_OK_TITLE: "¡Su Solicitud fue procesada correctamente!",
  CHANGE_NUMBER_BUTTON_MODAL_OK_SUBTITLE: 'Se procesará en las próximas 24 horas.<br> El número de orden es:',
  CHANGE_NUMBER_BUTTON_MODAL_OK_SUBTITLE_2: 'Puede hacer seguimiento <br> en "Solicitudes"',
  CHANGE_NUMBER_BUTTON_MODAL_OK_REQUEST: "Ir a Solicitudes",
  CHANGE_NUMBER_BUTTON_MODAL_OK_FAIL: "¡Su Solicitud de cambio de número no pudo ser procesada.",
  CHANGE_NUMBER_BUTTON_MODAL_OK_FAIL_TEXT: "Por favor comuníquese al *103",
  CHANGE_NUMBER_BUTTON_MODAL_OK_FAIL_TEXT_AGAIN: "Intentar nuevamente",
  CHANGE_NUMBER_LABEL_ERROR_REQUEST: "No se ha podido completar la solicitud. por favor intente más tarde.",
  CHANGE_NUMBER_LABEL_ERROR_GET_IMEI: "No se ha encontrado un IMEI asignado a esta línea.",
  CHANGE_NUMBER_UPLOAD: "Subir",
  CHANGE_NUMBER_SELECT_LINE: "Seleccione una línea...",
  CHANGE_NUMBER_LINE_ALERT: "Debe seleccionar una línea",
  CHANGE_NUMBER_LABEL_CONTENT_TITLE_4_STEP_3: "Suba una copia de su cédula de Identidad",
  CHANGE_NUMBER_LABEL_CONTENT_TITLE_5_STEP_3: "Puede subir 1 archivo con los 2 lados de su cédula o subir 1 archivo por cada lado de su cédula. (.PDF, .JPEG, .DOC)",
  CHANGE_NUMBER_LABEL_UPLOAD_DOCUMENT_COPY: "1 archivo",
  CHANGE_NUMBER_LABEL_UPLOAD_DOCUMENT_COPY_SUB: "(Dos lados de la CI)",
  CHANGE_NUMBER_LABEL_UPLOAD_DOCUMENT_COPY_FRONT: "Frente",
  CHANGE_NUMBER_LABEL_UPLOAD_DOCUMENT_COPY_REVERSE: "Reverso",
  CHANGE_NUMBER_LABEL_UPLOAD_FRONT_AND_REVERSE: "Suba el frente y reverso de su cédula por separado",
  CHANGE_NUMBER_BRAND_TERMS_CONDITIONS: "Acepto ",


  CHANGE_CHIP_LINE_SELECTED: "Seleccione su línea liberada que desea activar",
  CHANGE_CHIP_MODAL_TITTLE_FAIL:
    "No podemos realizar la Reposición de su Chip si su Línea se encuentra suspendida.",
  CHANGE_CHIP_MODAL_DESC_FAIL:
    "Por favor libere su línea y regresa para solicitar la reposición de su Chip",
  CHANGE_CHIP_BUTTON_TITLE_FAIL: "Ir a Liberación de Línea",
  //RATES_FOOTER
  RATES_FOOTER_LABEL_TITLE: "TARIFAS MAXIplus FUERA DE COMBOS Y BONOS",
  CARE_CHANNELS_FOOTER_TITTLE_GENERIC: "Sus Canales de Atención",
  CARE_CHANNELS_FOOTER_TITTLE_COMBOS: "Otras formas de Activar sus Combos",
  CARE_CHANNELS_FOOTER_NUMBER_SUBTITLE: "Marcando desde su celular",


  //CHANGE-CHIP
  CHANGE_CHIP_TITTLE: "Reposición de Chip",
  CHANGE_CHIP_SUB_TITTLE: `Con esta solicitud activará su número en su nuevo Chip <b>MAXIplus</b>`,
  CHANGE_CHIP_DESC: `Adquiera su Chip <b>MAXIplus</b>
en cualquiera de nuestros supermercados`,
  CHANGE_CHIP_SELECT_LINE: "Seleccione su línea liberada que desea activar",
  CHANGE_CHIP_SUB_NUMBER_TITTLE: "Ingrese el número ICC de su nuevo Chip ",
  CHANGE_CHIP_COPY_CC: "Suba una copia de su cédula de identidad",
  CHANGE_CHIP_DESC_CC: `Puede subir 1 archivo con los 2 lados de su cédula o subir 1 archivo
por cada lado de su cédula. (.PDF, .JPEG, .DOC)`,
  CHANGE_CHIP_ONE_FILE: "1 Archivo",
  CHANGE_CHIP_DESC_FILE: "Suba el frente y reverso de su cédula por separado",
  CHANGE_CHIP_FRONT_REVERSE_CC: "Cédula frente y reverso",
  CHANGE_CHIP_FRONT: "Frente",
  CHANGE_CHIP_REVERSE: "Reverso",
  CHANGE_CHIP_UPLOAD: "Subir",
  CHANGE_CHIP_DESC_AUTHORIZATION: "Autorizo a MAXIplus a reponer mi chip",
  CHANGE_CHIP_TERMS: "Acepto Términos y Condiciones",
  CHANGE_CHIP_REPLACEMENT_DESC: "Reponer mi Chip",
  CHANGE_CHIP_MODAL_TITTLE_OK: "¡Su SOLICITUD FUE PROCESADA CORRECTAMENTE!",
  CHANGE_CHIP_MODAL_DESC_OK: `Ya puede colocar el Chip en su celular.<br> 
  En 30 minutos recibirá una notificación <br>y podrá empezar a utilizar su línea.`,
  CHANGE_CHIP_BUTTON_TITLE: "Comprar combos o bonos",
  CHANGE_CHIP_MODAL_CONTENT_AUT_TERMS: "Debe aceptar la autorización de reposición de chip y aceptar los términos y condiciones",

  //LOGIN
  LOGIN_LABEL_MENU_ITEM: "Iniciar Sesión",
  LOGIN_LABEL_TITLE_1: "EN ",
  LOGIN_LABEL_TITLE_2: "SU CUENTA ",
  LOGIN_LABEL_TITLE_3: "En la sección SU CUENTA ENCONTRARÁ TODA SU INFORMACIÓN",
  LOGIN_LABEL_SUB_TITLE_1: "Detalles de consumos, estado de sus líneas, estado de sus requerimientos y muchas cosas más.",
  LOGIN_LABEL_SUB_TITLE_2: "¡DESCÚBRALAS!",
  LOGIN_LABEL_FORM_TITLE: "REGISTRO/LOGIN",
  LOGIN_LABEL_FORM_TITLE_PIN: " PIN",
  LOGIN_LABEL_INPUT_CC: "Número de documento",
  LOGIN_LABEL_INPUT_NUMBER: "Número MAXIplus",
  LOGIN_LABEL_INPUT_EMAIL: "Correo electrónico",
  LOGIN_LABEL_INPUT_PIN: "PIN de4 dígitos",
  LOGIN_LABEL_FORM_TITLE_2: "Pin 4 dígitos",
  LOGIN_LABEL_INPUT_PIN_RESEND_TEXT: "Si no ha recibido el pin,",
  LOGIN_LABEL_INPUT_PIN_RESEND_LINK: "solicítelo nuevamente",
  LOGIN_LABEL_BTN_SUBMIT: "Ingresar",
  LOGIN_LABEL_FOOTER_LINK_PORTABILITY: "QUIERO SER MAXIplus",
  LOGIN_LABEL_WRONG_PIN: "El código ingresado no es válido.",
  LOGIN_LABEL_RETRY_LIMIT: "Se ha agotado el número de reintentos.",
  LOGIN_LABEL_DUPLICATE_SESSION: "Ya tiene una sesión activa.",
  LOGIN_LABEL_BTN_LOGOUT: "Cerrar Sesión",
  LOGIN_LABEL_MODAL_CONTENT_USER_NOT_REGISTERED: "Usuario no registrado.",
  LOGIN_LABEL_MODAL_CONTENT_USER_NOT_REGISTERED_MAIN_DATA_PHONE: "Por favor ingrese el número telefónico.",
  LOGIN_LABEL_MODAL_CONTENT_USER_NOT_REGISTERED_MAIN_DATA_ALL: "Por favor llene todos los datos del formulario.",
  LOGIN_LABEL_MODAL_ERROR_SMS_TITLE: "Error",
  LOGIN_LABEL_MODAL_ERROR_SMS_CONTENT: "No se ha podido enviar el mensaje de texto al número indicado, por favor verifique el número e intente nuevamente",
  LOGIN_LABEL_DOCUMENT_CED: "Cédula",
  LOGIN_LABEL_DOCUMENT_PAS: "Pasaporte",
  LOGIN_LABEL_INPUT_DOC_TYPE: "Tipo de documento",
  LOGIN_ERROR_UNEXPECTED: "Error inesperado",
  LOGIN_ERROR_VALIDATION_USER: "Ha ocurrido un error al consultar el registro de los datos ingresados",

  BASIC_INFO_HEADER_DATA_LINES: "línea(s) prepago MAXIplus",
  BASIC_INFO_HEADER_DATA_EDIT: "Editar información",
  BASIC_INFO_HEADER_PRIVACY: "Mi Privacidad",
  BASIC_INFO_HEADER_DATA_PENDING: "Solicitud(es) pendiente(s)",
  BASIC_INFO_HEADER_DATA_DETAILS: "Ver detalle",
  BASIC_INFO_HEADER_DATA_HISTORY: "Ver historial",
  BASIC_INFO_HEADER_DATA_CALLS: "Ver detalle llamadas",
  BASIC_INFO_HEADER_DATA_NEW_BTN: "Nueva solicitud",
  BASIC_INFO_HEADER_LOADING: "Cargando...",

  //My account
  MY_ACCOUNT_LABEL_TITLE: `BIENVENID@ A <span class="f-karla-bold">MI CUENTA</span>`,

  //ORDER_HISTORY
  ORDER_HISTORY_LABEL_LINE_SELECTOR: "VER SOLICITUDES PARA LA LÍNEA",
  ORDER_HISTORY_LABEL_TABLE_DATE: "FECHA DE CREACIÓN",
  ORDER_HISTORY_LABEL_TABLE_NUM_TICKET: "N. DE SOLICITUD",
  ORDER_HISTORY_LABEL_TABLE_ORIGIN: "ORIGEN",
  ORDER_HISTORY_LABEL_TABLE_DETAIL: "DETALLE",
  ORDER_HISTORY_LABEL_TABLE_STATE: "ESTADO",
  ORDER_HISTORY_LABEL_ERROR_NO_DATA: "No hay datos disponibles",
  ORDER_HISTORY_LABEL_ALL_LINES: "Todas",

  //CREATE_TICKET
  CREATE_TICKET_LABEL_SUCCESS_REQUEST: "Su solicitud fue creada con éxito. Número de ticket: ",
  CREATE_TICKET_LABEL_ERROR_REQUEST: "Su solicitud no fue procesada, por favor intente más tarde.",

  CREATE_TICKET_LABEL_TITLE: "Nueva Solicitud",
  CREATE_TICKET_LABEL_DESC: "Por medio de la creación de nuevas solicitudes podrá tener solución a sus necesidades.",
  CREATE_TICKET_LABEL_TYPE: "Tipo",
  CREATE_TICKET_LABEL_ADD_NUMBER: "Número celular opcional",
  CREATE_TICKET_LABEL_SUMMARY: "Descripción",
  CREATE_TICKET_LABEL_BTN: "Solicitar",
  CREATE_TICKET_LABEL_AFFECTED_LINE: "Línea afectada",
  CREATE_TICKET_LABEL_SELECT_LINE: "Seleccione una línea",
  CREATE_TICKET_LABEL_SELECT_REQUEST: "Seleccione una solicitud",

  //RECHARGE
  RECHARGE_LABEL_HEADER_TITLE: "Comprar una recarga",
  RECHARGE_LABEL_HEADER_SUBTITLE: "Usa cualquier tarjeta de débito o crédito",
  RECHARGE_LABEL_TAB_STEP_1: "Número y valor a recargar",
  RECHARGE_LABEL_TAB_STEP_2: "Pagar",
  RECHARGE_MODAL_CONTENT_CARD_VALIDATION: "Debe seleccionar una tarjeta",
  RECHARGE_CARD_REMOVE_ERROR: "No se ha podido eliminar la tarjeta, intente más tarde.",
  RECHARGE_AMOUNT_ERROR: "Seleccione una cantidad a recargar.",
  RECHARGE_LABEL_NUMBER: "Número MAXIplus",

  RECHARGE_LABEL_MY_LINES: "Mis líneas",
  RECHARGE_LABEL_OTHER_NUMBER: "Otro número",
  RECHARGE_LABEL_AMOUNT: "Valor a recargar",
  RECHARGE_LABEL_PAY_WAY: "Verifica la información y verifica tu forma de pago",
  RECHARGE_LABEL_NUMBER_TO_RECHARGE: "Número al que se realizará la compra",
  RECHARGE_LABEL_FINAL_COST: "Costo final",

  RECHARGE_LABEL_TYPE_BUY: "Tipo de Compra",

  VALID_RECURRENT_TYPE: "recurrent",



  RECHARGE_LABEL_SAVE_CARD: "Guardar tarjeta en Su cuenta",
  RECHARGE_LABEL_SELECT_CARD: "Selecciona la tarjeta con la que se realizará el pago:",
  RECHARGE_LABEL_NEW_CARD: "Pagar con otra tarjeta",
  RECHARGE_LABEL_PAYMENT_ERROR_PAGE: "Error en el proceso de pago",
  RECHARGE_LABEL_PAYMENT_OK_PAGE: "Detalles de la Compra",

  RECHARGE_LABEL_PAYMENT_OK_PAGE_RECURRENT: "Beneficios acreditados",

  RECHARGE_LABEL_PAYMENT_OK_PAGE_COST: "Costo final:",
  RECHARGE_LABEL_PAYMENT_OK_PAGE_CARD: "Tarjeta de Crédito/Débito:",
  RECHARGE_LABEL_PAYMENT_OK_PAGE_AUTH_NUM: "Número de Autorización:",
  RECHARGE_LABEL_PAYMENT_OK_PAGE_TX_NUM: " Número de Transacción:",
  RECHARGE_LABEL_PAYMENT_OK_PAGE_DATE: "Fecha:",
  RECHARGE_LABEL_PAYMENT_OK_PAGE_TITLE: "¡EL PAGO SE REALIZÓ CORRECTAMENTE!",

  RECHARGE_LABEL_PAYMENT_NUMBER_MAXIPLUS: "Número MAXIplus",
  RECHARGE_LABEL_PAYMENT_VALUE_FINISH: "Costo final",

  HELP_LABEL_TITLE_INFO: "¿EN QUÉ PODEMOS AYUDARLE?",

  //RATES
  RATES_LABEL_MODAL_TITLE: "Precios de tarifas",
  RATES_LABEL_MODAL_SUBTITLE_TYPE: "Tipo",
  RATES_LABEL_MODAL_SUBTITLE_VALUE: "Precio",
  RATES_LABEL_MODAL_IVA: "IVA",
  RATES_LABEL_MODAL_INCL_IVA: "Incl IVA",
  RATES_LABEL_LINK_TAXES: "Ver tarifas",



  //COBERTURA
  TITLE_MAP_COVERAGE: "Mapas de Cobertura",
  MAP_COVERAGE_TEXT: "Navega y visualiza la cobertura de nuestro servicio móvil en las tecnologías 4G LTE, 3G y 2G a nivel nacional.<br/>A continuación, selecciona la tecnología y la zona que deseas consultar:",
  MAP_COVERAGE_DATE: "Fecha de actualización 16/Enero/2020",
  MAP_CONDITION: "Condiciones mapas de cobertura",
  MAP_CONDITION_TEXT: "Los mapas de cobertura mostrados se basan en simulaciones generadas a partir de modelos de propagación utilizados en general por la industria de servicios de telecomunicaciones móviles, aplicadas en bases cartográficas digitales. Las simulaciones generan estimaciones de cobertura en función del tipo de terreno, obstáculos naturales o artificiales (inmuebles, construcciones, etc.), banda de frecuencias, volumen de tráfico o cantidad de comunicaciones concurrentes, sensibilidad de los equipos terminales con los que se accede al servicio, condiciones climáticas, tipo de vegetación o edificaciones cercanas, características en general del equipamiento y de operación en las estaciones base, entre otros aspectos.",
  MAP_CONDITION_TEXT_2: "En tal razón, los mapas de cobertura aquí mostrados, al basarse en predicciones, deben considerarse como referenciales o aproximados, pudiendo el abonado, cliente o usuario, experimentar niveles de señal o disponibilidad en el uso o accesos al servicio en una zona o ubicación específicos, diferentes a los mostrados en los mapas. Debido adicionalmente a los factores ya indicados, al uso del equipo terminal indoor (dentro de edificaciones), uso en túneles, interferencia de otras señales u otros aspectos que se presenten al momento de utilizar el servicio. Los mapas de cobertura han sido generados considerando los niveles de señal dispuestos en el ordenamiento jurídico vigente.",
  MAP_SEE_NAVEGATOR: "Para una mejor experiencia recomendamos navegar con los siguientes navegadores:",





  //Saldos y consumos
  LABEL_ERROR_SERVICE_BILLING: 'Se presento una excepciòn al consultar la factura',
  STATUS_ACTIVE: 'Activo',
  TYPE_BUY: 'TIPO DE COMPRA',
  RECURRENT: 'Recurrente',
  DETAIL_RECURRENT: 'Detalle',
  MODEL_RECURRENT_TITLE: 'COMBOS MAXIplus RECURRENTES',
  MODEL_RECURRENT_SUB_TITLE: 'Tiene activo el débito recurrente para:',
  MODEL_RECURRENT_SUB_TITLE_2: 'Vas a activar el débito recurrente para:',
  MODEL_RECURRENT_SUB_TITLE_FOOTER: 'Si tiene alguna duda, comuníquese a *103',
  MODEL_RECURRENT_COMBO: 'COMBO:',
  MODEL_RECURRENT_CARD: 'TARJETA:',
  MODEL_RECURRENT_ACTIVA: 'SE ACTIVARÁ:',
  MODEL_RECURRENT_NEXT_DEBIT: 'PRÓXIMO DÉBITO:',
  MODEL_RECURRENT_SELECT_BILLING: 'Consultar',
  MODEL_RECURRENT_SELECT_BILLING_2: 'Facturas',
  MODEL_RECURRENT_CANCEL_DEBIT: 'Cancelar          ',
  MODEL_RECURRENT_CANCEL_DEBIT_2: 'Débito Recurrente',
  MODEL_RECURRENT_CARD_TOKEN: 'xxxx xxxx xxxx ',
  MODEL_RECURRENT_CANCEL_COMBO: '¿Está seguro que quiere cancelar el débito recurrente de su combo ',
  MODEL_RECURRENT_CANCEL_COMBO_2: '?',
  MODEL_RECURRENT_CANCEL_COMBO_BTN_NO: 'No, quiero comprar otro combo',
  MODEL_RECURRENT_CANCEL_COMBO_BTN_YES: 'Sí, quiero cancelar mi combo recurrente',
  MODEL_RECURRENT_CANCEL_COMBO_OK: 'Se ha cancelado el débito recurrente de su ',
  MODEL_RECURRENT_CANCEL_COMBO_OK2: '.',
  MODEL_RECURRENT_CANCEL_COMBO_OK3: 'Su combo estará vigente hasta el ',
  MODEL_RECURRENT_CANCEL_COMBO_OK4: '¡Le extrañaremos!',
  MODEL_RECURRENT_CANCEL_ERROR: 'Error al cancelar el combo recurrente.',
  MODEL_RECURRENT_ERROR_GET: 'Error al obtener el metodo de pago del combo recurrente',
  MODEL_RECURRENT_FACTURAS: 'FACTURAS DE TUS COMBOS RECURRENTES',
  MODEL_RECURRENT_PREVIOUS: 'ANTERIOR',
  MODEL_RECURRENT_NEXT: 'SIGUIENTE',
  TYPE_COMBO: 'COMBO',
  TYPE_BONO: 'BONO',
  ONLY: 'Única',
  STATUS_SUSPEND: 'Suspendido',
  MY_LINE: 'Mi línea',
  SELECT_LINE: 'Seleccionar línea a consultar',
  MY_EQUIPMENT: 'Mi Equipo',
  SUPEND: 'Suspender',
  DETAIL_CALL: 'Detalle de llamadas',
  MY_PACKAGES: 'MIS PAQUETES',
  BUY_CMD: 'COMPRAR COMBO',
  BUY_BOLTON: 'COMPRAR BONO',
  TYPE_PACKAGE: 'TIPO DE PAQUETE',
  TYPE_PACKAGE2: 'PAQUETE',
  NAME: 'NOMBRE',
  DUEDATE_CMB: 'VIGENTE HASTA',
  PENDING_CMB: 'QUEDAN',
  BALANCE_AND_BOLTON: 'MIS SALDOS Y CONSUMOS',
  BALANCE_RECARGUE: 'Saldo en Recargas',
  SEE_DETAIL: 'Ver detalle',
  RECHARGUE: 'RECARGAR',
  PENDING_CMB_DETAILS: 'Te quedan',
  OF_CMB: 'de',
  UNLIMITED: 'Ilimitados',
  SEE_DETAIL_CONSUMER_DETAIL: 'DETALLE DEL CONSUMO DE ',
  SEE_DETAIL_CONSUMER_OTHER_DETAIL: 'DETALLE DEL CONSUMO DE OTROS ',
  BALANCE_AND_LABEL_MODAL_ERROR_SENDING_REQUEST: "Ha ocurrido un error consultando el detalle de los saldos y consumos. intente más tarde.",
  BALANCE_AND_LABEL_MODAL_ERROR_SENDING_REQUEST_EQUIP: "Ha ocurrido un error consultando el detalle del equipo móvil. Sin embargo intentará consultar los saldos y consumos.",
  DAYS: 'dìas',
  HOURS: 'horas',
  NETWORK_SOCIAL: 'NINGUNA',

  //Homologación
  HOMOLOGATION_TITTLE: "Homologación de equipos terminales móviles",
  HOMOLOGATION_SUB_TITTLE_1: "¿Qué es la HOMOLOGACIÓN y para qué sirve?",
  HOMOLOGATION_PARAGRAPH_1_1: `La Homologación es el proceso por el cual un equipo terminal de una clase,
   marca y modelo es sometido a verificación del cumplimiento de normas 
   técnicas para determinar si es adecuado para operar en una red de 
   telecomunicaciones específica.`,
  HOMOLOGATION_PARAGRAPH_1_2: ``,
  HOMOLOGATION_PARAGRAPH_1_2_LIST: `
    <li>Prevenir daño en las redes de telecomunicaciones</li> 
    <li>Evitar la perturbación técnica a los servicios de telecomunicaciones o su deterioro</li> 
    <li>Evitar interferencia perjudicial al espectro radioeléctrico</li> 
    <li>Contribuir con una óptima calidad en la prestación de los servicios de telecomunicaciones</li> 
  `,
  HOMOLOGATION_SUB_TITTLE_2: "¿Cómo podemos verificar si un equipo terminal está homologado?",
  HOMOLOGATION_PARAGRAPH_2_1: "Para verificar si un equipo terminal está homologado, puedes ingresar a la siguiente página de ARCOTEL:",
  HOMOLOGATION_PARAGRAPH_2_1_LINK: `http://tucelularlegal.arcotel.gob.ec/tucelularlegal/`,
  HOMOLOGATION_PARAGRAPH_2_2: `En la misma se realiza la búsqueda mediante el IMEI (Identificador Internacional de Equipo Móvil),
     si no conoces este número, lo puedes obtener ingresando el código *#06# desde el equipo,
      el cual debe coincidir con el IMEI (serie) externa.`,
  HOMOLOGATION_SUB_TITTLE_3: "¿Dónde y cómo puedo homologar un terminal?",
  HOMOLOGATION_PARAGRAPH_3_1: `En Ecuador, la institución que emite el Certificado de Homologación es la Agencia de Regulación
       y Control de las Telecomunicaciones (ARCOTEL).`,
  HOMOLOGATION_PARAGRAPH_3_2: "Entre los requisitos establecidos tenemos:",
  HOMOLOGATION_PARAGRAPH_3_2_LIST: `
  <li>Solicitud dirigida a la Dirección Ejecutiva ARCOTEL, en el formato establecido para el efecto.</li> 
  <li>Manual de usuario o documento emitido por el fabricante en formato digital, en el que consten las especificaciones técnicas, 
  marca y modelo del equipo.</li> 
  <li>Fotografías del equipo en formato digital de acuerdo a las especificaciones establecidas por la ARCOTEL.</li> 
  <li>Certificado de características técnicas, en formato digital o en el evento de que el solicitante cuente con un certificado 
  de homologación otorgado por un organismo o institución internacional reconocido por la ARCOTEL, deberá adjuntar dicho documento 
  a la solicitud correspondiente, sin otro requisito adicional.</li>
  <li>A partir del 12 de abril del 2021 el trámite de homologación es SIN COSTO.</li>
  `,
  HOMOLOGATION_PARAGRAPH_3_3: `El costo por derechos de homologación corresponde a una tasa del 37.43% de un salario básico 
  unificado (SBU) vigente, es decir, para el año 2018 se establece un valor de $144.48.`,
  HOMOLOGATION_PARAGRAPH_3_4: `Conoce más a detalle sobre este procedimiento en: <a href="http://www.arcotel.gob.ec/homologacion/" target="_blank">http://www.arcotel.gob.ec/homologacion/</a>`,
  HOMOLOGATION_SUB_TITTLE_4: "Sugerencia, antes de comprar un terminal:",
  HOMOLOGATION_PARAGRAPH_4_1: `Antes de comprar un terminal, te sugerimos consultar si el equipo está homologado en Ecuador, 
  y que no se encuentre adulterado o robado.`,
  HOMOLOGATION_LINK_RULES_1: `Reformas Reglamento Homologación y Certificación de Equipos`,
  HOMOLOGATION_LINK_RULES_2: `Reglamento Homologación y Certificación de Equipos`,


  //COMBOS
  COMBOS_LABEL_TITLE_BRAND: "MAXIplus combos",
  COMBOS_LABEL_TITLE_MOUNT: "Combos para todo el mes",
  COMBOS_LABEL_TITLE_EXPRESS: "Combos express",
  COMBO_LABEL_TOOLTIP_BALANCE: "Saldo disponible: ",
  COMBOS_LABEL_MODAL_ERROR_LINE_NOT_IN_BRAND: "La línea indicada no pertenece a MAXIplus",
  COMBOS_LABEL_ERROR_AUTH_DEBIT: "Debe aceptar la autorización de debitar de su saldo.",
  COMBOS_LABEL_TITLE_SUCCESS: "El débito desde su saldo de recargas se realizó correctamente",
  COMBOS_LABEL_CONTENT_TITLE_LEFT: "Beneficios acreditados",
  COMBOS_LABEL_CONTENT_TITLE_RIGTH: "Detalles de la compra",
  COMBOS_LABEL_BTN_FINISH_PAYMENT: "Pagar",
  COMBOS_LABEL_WIZ_TITLE: "Compre su COMBO o BONO preferido",
  COMBOS_LABEL_WIZ_SUBTITLE: "Con saldo de sus recargas o cualquier tarjeta de débito o crédito",
  COMBOS_LABEL_WIZ_STEP_1_TITLE: "Verificar combo y número",
  COMBOS_LABEL_WIZ_STEP_2_TITLE: "Seleccionar forma de pago",
  COMBOS_LABEL_WIZ_STEP_3_TITLE: "Pagar",
  COMBOS_LABEL_WIZ_STEP_1_CONTENT_TITLE: "Verifique el Combo y número MAXIplus al que desea comprar.",
  COMBOS_LABEL_WIZ_STEP_2_CONTENT_TITLE: "Seleccione su forma de pago para comprar su combo",
  COMBOS_LABEL_WIZ_SELECTED_NUMBER: "Número al que se realizará la compra",
  COMBOS_LABEL_WIZ_PAYMENT_METHOD: "Seleccione su forma de Pago",

  COMBOS_LABEL_PAYMENT_RECURRENT: "Seleccione su tipo de compra",


  COMBOS_LABEL_BTN_BALANCE_IN_RECHARGE: "Saldo de recargas",

  COMBOS_LABEL_BTN_UNIC: "Única",


  COMBOS_LABEL_BTN_CREDITCARD: "Tarjeta de Débito o Crédito",

  COMBOS_LABEL_BTN_RECURRENT: "Recurrente",


  COMBOS_LABEL_STEP_3_CONTENT_TITLE_2: "Verifique la información para finalizar su compra",
  COMBOS_LABEL_STEP_3_CONTENT_TITLE: "Complete los datos de su Tarjeta de Débito o Crédito para realizar su compra",
  COMBOS_LABEL_STEP_3_CONTENT_TITLE_RECHARGE: "Verifica la información para finalizar tu compra",
  COMBOS_LABEL_STEP_3_CONTENT_TITLE_RECURRENT: "Complete los datos de su Tarjeta de Débito o Crédito para realizar su compra y registrar su débito recurrente",

  COMBOS_LABEL_SELECTED_COMBO: "Combo seleccionado",
  COMBOS_LABEL_VALIDITY: "Vigencia",
  COMBOS_LABEL_AVALABLE_BALANCE: "Saldo en Recargas disponible",
  COMBOS_LABEL_AUTH_CHECK_1: "Autorizo a MAXIplus debitar",
  COMBOS_LABEL_AUTH_CHECK_2: "de mi Saldo de Recargas",
  COMBOS_LABEL_DATE: "Fecha",
  COMBOS_MAIN_TITLE: "Aquí puede comprar su<br><b>COMBO</b> o <b>BONO</b> preferido",
  COMBOS_HEADER_ITEM_1: "Sin contratos",
  COMBOS_HEADER_ITEM_2: "Sin recurrencias",
  COMBOS_HEADER_ITEM_3: "Sin límite de activaciones",
  COMBOS_HEADER_ITEM_4: "Sin realizar una recarga previa",
  COMBOS_HEADER_ITEM_5: "Compras individuales",
  COMBOS_HEADER_ITEM_6: "Compras recurrentes",
  COMBOS_MAIN_CONTENT_TITLE: "Compre su COMBO o BONO preferido",
  COMBOS_MAIN_CONTENT_SUBTITLE: "Con saldo de sus recargas o cualquier tarjeta de débito o crédito",


  //PORTABILITY_BUGS
  PORTABILITY_LABEL_FINISH_PROCESS_1: "¡Su solicitud fue procesada correctamente!",
  PORTABILITY_LABEL_FINISH_PROCESS_2: "En 2 días hábiles recibirá una notificación para que realice el cambio de su chip en su celular",
  PORTABILITY_LABEL_FINISH_PROCESS_3: "Hasta que reciba la notificación puede seguir utilizando su línea actual",
  PORTABILITY_LABEL_FINISH_PROCESS_4: "Si tiene alguna duda comuníquese al *103",
  ACTIVATION_PASSPORT_AGE_LIMIT: "Debe ser mayor de edad para realizar este proceso.",

  //GENERAL ACTIONS
  EXTENSION_FILE_INVALID_TITTLE: "Validación",
  EXTENSION_FILE_INVALID: "La extensión del archivo seleccionado no es valido.",

  //PAYMENT_BUGS
  PAYMENT_COMMONS_TX_IN_PROCESS: "Existe una transacción en proceso, por favor espere.",
  PAYMENT_COMMONS_NO_VALID_OFFER: "El producto no se encuentra disponible para la línea seleccionada.",
  PAYMENT_COMMONS_INSUFFICIENT_BALANCE: "El abonado no tiene saldo suficiente para la contratación.",

  //Movistar Play
  M_PLAY_HOME_TITTLE: `Movistar Play<br>DEPORTES, ENTRETENIMIENTO Y MÁS`,
  M_PLAY_HOME_SUB_TITTLE: `Movistar Play el complemento perfecto en su <br>línea Maxiplus con navegación incluida.`,
  M_PLAY_HOME_SHOW_MORE: `Conoce más`,
  M_PLAY_HOME_DIRECT: `EN DIRECTO`,
  M_PLAY_HOME_CINE: `CINE`,
  M_PLAY_HOME_SERIES: `SERIES`,
  M_PLAY_HOME_CHILDRENS: `INFANTIL`,
  M_PLAY_HOME_DOC: `DOCUMENTALES`,
  M_PLAY_TITTLE: `<b class="c-violeta">Movistar Play</b> es una plataforma online donde
  podrá ver y disfrutar
  sus series,
  películas, documentales y TV Online, dónde y cuándo quiera.`,
  M_PLAY_SUB_TITTLE: `Si es MAXIplus, <b>la suscripción y paquete básico son gratis</b>`,
  M_PLAY_REGISTER: `Regístrese`,
  M_PLAY_REGISTER2: `Registrarme`,
  M_PLAY_TITTLE_PART2: `Disfrute`,
  M_PLAY_SUB_TITTLE_PART2: `Todo el contenido <b>sin salir
  de tu Movistar Play </b>
en cualquiera de tus dispositivos.`,
  M_PLAY_LOGIN: `Iniciar sesión`,

  PHONE_VALIDATOR_ERROR_ZERO: "Por favor, especifique un número de teléfono celular correcto. Ejemplo: 0995465324",

  LABEL_FROM_TO: "Hasta ",
  LABEL_MINUTES: "MINUTOS",

  //NORMATIVES
  NORMATIVE_TITTLE: "Normativas",
  NORMATIVE_TITTLE_1: "Norma técnica que regula las condiciones generales de los contratos de adhesión, del contrato negociado con clientes, y del empadronamiento de abonados y clientes",
  NORMATIVE_TITTLE_2: "Reglamento a la ley de defensa del consumidor",
  NORMATIVE_TITTLE_3: "Ley orgánica de defensa del consumidor",
  NORMATIVE_TITTLE_4: "Procedimiento de devolución de saldos remanentes de recargas",
  NORMATIVE_TITTLE_5: "Política de Privacidad",

    //Firma
    SIGNATURE_BUTTON_OPEN_PDF: "Ver PDF",
    SIGNATURE_BUTTON_CLEAN_PDF: "Borrar firma",
    SIGNATURE_PDF_NOT_OPEN: "Debe ver al menos una vez el pdf con todos tus datos ingresados, incluyendo la firma",
  
  //GD-1335
  //Uso 911
  USO_911_TITULO_PAG: "Uso correcto del 911",
  USO_911_OPC_1: "Use bien el 911",
  USO_911_OPC_2: "Consulte el estado de su línea",  
  USO_911_LINK: "https://www.ecu911.gob.ec/lineas-suspendidas/",

  //parametro getListParamGroups
  paramsPolicy : "COOKIE_POLITICA_PRIVACIDAD_DATOS",

  //Nombre de la marca
  BRAND_NAME : "MAXIplus"

    
}; 